<template>
  <div id="full_bg" :class="themeColor"></div>
  <v-app :theme="themeColor">
    <Navigation :appVersion="appVersion" />

    <v-main>
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.path" />
      </router-view>

      <ReloadPWA />
    </v-main>
    <FooterBar />
  </v-app>
  <teleport to="head">
    <meta name="theme-color" :content="themeColor" />
    <!--link rel="icon" :href="logo" type="image/svg+xml" /-->
  </teleport>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useSiteStore } from "@/stores/site";
import { useNewsStore } from "@/stores/news";
import { useRegionStore } from "@/stores/region";
import { useRegionsStore } from "@/stores/regions";
import { useLocationsStore } from "@/stores/locations";
import { useAuthStore } from "@/stores/auth";

import { useRouter, useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import i18n from "@/i18n";

import Navigation from "@/components/Layout/Navigation.vue";
import FooterBar from "@/components/Layout/FooterBar.vue";
import ReloadPWA from "@/components/ReloadPWA.vue";

const siteStore = useSiteStore();
const newsStore = useNewsStore();
const regionStore = useRegionStore();
const regionsStore = useRegionsStore();
const locationsStore = useLocationsStore();
const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const toast = useToast();

const language = computed(() => siteStore.language);
const themeColor = computed(() => siteStore.getThemeColor);

const appVersion = __APP_VERSION__;

onMounted(async () => {
  siteStore.setLanguage(language.value);
  siteStore.setName();
  await authStore.init().then((reason) => {
    regionsStore.load();
    regionStore.load();
    locationsStore.load();
  });
});
</script>
<style lang="scss"></style>
